import type { JSX } from "preact";
import type { RenderLeafProps } from "slate-react";

export function Leaf({
    leaf,
    attributes,
    children,
}: RenderLeafProps): JSX.Element {
    // oxlint-disable-next-line typescript/no-unsafe-assignment
    let updatedChildren = children;
    if (leaf.bold) {
        updatedChildren = <strong>{updatedChildren}</strong>;
    }
    if (leaf.italic) {
        updatedChildren = <em>{updatedChildren}</em>;
    }
    if (leaf.underline) {
        updatedChildren = <u>{updatedChildren}</u>;
    }
    if (leaf.code) {
        updatedChildren = <code>{updatedChildren}</code>;
    }
    if (leaf.strikethrough) {
        updatedChildren = (
            <span className="text-decoration-line-through">
                {updatedChildren}
            </span>
        );
    }
    return <span {...attributes}>{updatedChildren}</span>;
}
